<script>
import { getClientType } from '@utils/client'

export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    lat: {
      type: [Number, String],
      required: false,
      default: '0.0',
    },
    lon: {
      type: [Number, String],
      required: false,
      default: '0.0',
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    clientType() {
      return getClientType()
    },
  },
  mounted() {},
  methods: {
    naviconHandler() {
      // window.dataLayer.push({
      //   event: '外部サイトへの遷移',
      //   event_action:
      //     'applink://navicon?lat=' + this.lat + '&lon=' + '&title=' + this.name,
      //   event_category: '外部サイト遷移',
      //   ap_screen_name: '優待_案内手段選択',

      //   ap_member_id: this.$store.state.auth.memberNo,
      //   ap_member_type: localStorage.getItem('userType'),
      // })
      window.location.href = `applink://navicon?lat=${this.lat}&lon=${this.lon}&title=${this.name}`
    },
    googlemapsHandler() {
      // window.dataLayer.push({
      //   event: '外部サイトへの遷移',
      //   event_action:
      //     'https://www.google.com/maps/?daddr=' + this.lat + ',' + this.lon,
      //   event_category: '外部サイト遷移',
      //   ap_screen_name: '優待_案内手段選択',

      //   ap_member_id: this.$store.state.auth.memberNo,
      //   ap_member_type: localStorage.getItem('userType'),
      // })
      window.open(
        `https://www.google.com/maps/?daddr=${this.lat},${this.lon}&dirflg=d`,
        '_blank'
      )
    },
    mapsHandler() {
      // window.dataLayer.push({
      //   event: '外部サイトへの遷移',
      //   event_action: 'applink://iosmap?lat=' + this.lat + 'lon=' + this.lon,
      //   event_category: '外部サイト遷移',
      //   ap_screen_name: '優待_案内手段選択',

      //   ap_member_id: this.$store.state.auth.memberNo,
      //   ap_member_type: localStorage.getItem('userType'),
      // })
      window.open(
        `http://maps.apple.com/?daddr=${this.lat},${this.lon}&dirflg=d`,
        '_blank'
      )
    },
    cancelHandler() {
      this.$emit('cancel')
    },
  },
}
</script>

<template>
  <div id="modals">
    <transition class="modal">
      <div
        v-if="show === true"
        id="modal_back_cover"
        @click.self="cancelHandler"
      >
        <div id="modal_set">
          <div class="modal_contents">
            <div class="modal_inner">
              <div class="sentence">
                <div class="head_title">
                  案内で使用するアプリを選択してください
                </div>

                <div class="app_list">
                  <div class="one_app_set" v-if="clientType === 0">
                    <a class="icon_link_cover" @click="mapsHandler">
                      <img src="@img/applink/icon_maps.png" />
                      <p class="name">マップ</p>
                    </a>
                  </div>
                  <div class="one_app_set">
                    <a class="icon_link_cover" @click="googlemapsHandler">
                      <img src="@img/applink/icon_googlemaps.png" />
                      <p class="name">GoogleMaps</p>
                    </a>
                  </div>
                </div>
                <div class="button_area">
                  <a
                    href="JavaScript:void(0);"
                    :class="['button']"
                    @click="cancelHandler"
                    >キャンセル</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
@import '@assets/css/SU-09.scss';
</style>
